import axiosPrivate from "./axiosPrivate";

const getPlanillas = () => {
  return axiosPrivate.get("planilla-viaticos");
};

const insertPlanilla = (data) => {
  return axiosPrivate.post("planilla-viaticos", data);
};

const updatePlanilla = (data) => {
  return axiosPrivate.put("planilla-viaticos", data);
};

const deletePlanilla = (planilla_id) => {
  return axiosPrivate.delete("planilla-viaticos", {
    data: { planilla_id }
  });
};

const validarPlanillaEmpleado = (planilla_id) => {
  return axiosPrivate.post("viaticos-planilla/validar", { planilla_id });
};

const ViaticosPlanillaService = {
  getPlanillas,
  insertPlanilla,
  updatePlanilla,
  deletePlanilla,
  validarPlanillaEmpleado
};

export default ViaticosPlanillaService;
